import { CornerRadiiState } from './cornerRadii.types';

import { RootState } from '~/redux/store';

export const selectSelectedCornerRadius = ({
  cornerRadius,
}: RootState): CornerRadiiState['selectedCornerRadius'] =>
  cornerRadius.selectedCornerRadius;
